module.exports = __webpack_public_path__ + "img/imgavatar.00a3ff7c.png";